import ApiConfig from "../../Utils/Configs/apiConfig";
import axios from "axios";
import { S3ObjectLocation } from "./S3ObjectLocation.utils";
import { getClientConfig } from "../../config/clientConfig";
import { buildS3ObjectKey } from "./buildS3ObjectKey";

/**
 * Service to upload images to AWS S3 Bucket.
 * Object key is built on the frontend for now; backend will own this later.
 */
export const AwsS3ImageService = async (
  client: any,
  file: any
): Promise<string | null> => {
  const clientConfig = getClientConfig();
  try {
    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    const contentType = getContentType(fileExtension);
    const s3ObjectKey = buildS3ObjectKey(client, file.name);

    if (!contentType || !s3ObjectKey) {
      console.error("Invalid file type or client is missing");
      return null;
    }

    const signedURL = await uploadSignedUrl({
      bucketName: clientConfig.s3.name,
      fileName: s3ObjectKey,
      contentDisposition: "inline",
      contentType: contentType,
      expirySeconds: 604800,
    });

    await axios.put(signedURL.data.data, file, {
      headers: {
        "Content-Type": contentType,
        "Content-Disposition": "inline",
      },
    });

    const location = S3ObjectLocation({
      bucketName: clientConfig.s3.name,
      fileName: s3ObjectKey,
      region: clientConfig.s3.region,
    });

    return location || null;
  } catch (error: any) {
    console.error("Error occurred during S3 upload:", error.message);
    return null;
  }
};

const getContentType = (extension: string): string | null => {
  switch (extension) {
    case "pdf":
      return "application/pdf";
    case "jpg":
    case "jpeg":
      return "image/jpeg";
    case "png":
      return "image/png";
    default:
      return null;
  }
};

const uploadSignedUrl = async ({
  bucketName,
  fileName,
  contentDisposition,
  contentType,
  expirySeconds,
}: uploadSignedUrlProps) => {
  return ApiConfig.getInstance().post("/AwsS3/GeneratePreSignedUploadUrl", {
    bucketName: bucketName,
    fileName: fileName,
    contentDisposition: contentDisposition,
    contentType: contentType,
    expirySeconds: expirySeconds,
  });
};

interface uploadSignedUrlProps {
  bucketName: string;
  fileName: string;
  contentDisposition: string;
  contentType: string;
  expirySeconds: number;
}
